import React from "react";
import MobileSidebar from "./mobile-sidebar";
import DesktopSidebar from "./desktop-sidebar";
import { useMedia } from "hooks/useMedia";

const SplitViewComponent = ({ sidebar, children, showSidebar, onToggle }) => {
  const { isMobile } = useMedia();

  return (
    <>
      <div className="__splitview_container">
        {isMobile ? (
          <MobileSidebar
            sidebar={sidebar}
            showSidebar={showSidebar}
            onToggle={onToggle}
          />
        ) : (
          <DesktopSidebar
            sidebar={sidebar}
            showSidebar={showSidebar}
            onToggle={onToggle}
          />
        )}
        <div className="splitview_content">{children}</div>
      </div>
      <style>{`
        .__splitview_container {
          position: relative;
          display: flex;
          flex-direction: row;
          flex: 1;
        }

        .splitview_content {
          position: relative;
          flex: 1;
          width: 100%;
          padding: 1em;
        }

      `}</style>
    </>
  );
};

export default SplitViewComponent;
